import VendorForm from "./VendorForm";
import { KAvatarAutocomplete } from "kinnect-general";
import { FacilityMaintenanceVendor } from "kinnect-models";
import { VDialog, VIcon } from "vuetify/lib";

export default {
	name: "VendorField",

	extends: KAvatarAutocomplete,

	props: {
		itemSelectionText: {
			default: "nameWithType",
			type: String
		},
		itemText: {
			default: "name",
			type: String
		},
		itemValue: {
			default: "id",
			type: String
		},
		noDataText: {
			default: "No vendors to display",
			type: String
		},
		prependIcon: {
			default: "assignment_ind",
			type: String
		},
		showAddButton: Boolean
	},

	data: () => ( {
		dialogOpen: false
	} ),

	methods: {
		createItem( { data: item } ) {
			this.$emit( "create", new FacilityMaintenanceVendor( item ) );
		}
	},

	render() {
		return <KAvatarAutocomplete
			attrs={{
				...this.$props,
				groupBy: "vendorType.name"
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{ ...this.$scopedSlots }}
		>
			{this.showAddButton && <VDialog
				class="white"
				persistent
				scopedSlots={{ activator: ( { on } ) => <VIcon on={on}>add_circle</VIcon> }}
				slot="append-outer"
				vModel={this.dialogOpen}
				width="500"
			>
				{this.dialogOpen && <VendorForm
					formTitle={"Add a Vendor"}
					onClose={() => this.dialogOpen = false}
					onSuccess={this.createItem}
				></VendorForm>}
			</VDialog>}
		</KAvatarAutocomplete>;
	}
};
